<div class="flex min-h-screen flex-col">
  <app-header />
  <app-topnav />

  <!-- Nota de rol (según el selector del topbar) -->
  <div class="px-5 pt-5 lg:px-8">
    <div
      class="flex items-center gap-2.5 rounded-xl border border-brand-100 bg-brand-50/70 px-4 py-2.5 font-ui text-theme-sm text-gray-700"
    >
      <span class="text-base">👁️</span>
      <span>{{ auth.notaRol() }}</span>
    </div>
  </div>

  <main class="flex-1 px-5 py-5 lg:px-8 lg:py-6">
    <router-outlet />
  </main>
</div>

<p-toast position="top-right" />
